'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n'], ['\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0; left: 0;\n  perspective: 1000px;\n  perspective-origin: ', ' 50%; // for some reason safari requires the x origin to be centered while other browsers require it to be offset to the left or right\n  width: 100%;\n  height: 100%;\n  z-axis: ', ';\n  transform-origin: ', ' center;\n  transform-style:preserve-3d;\n  transition: transform ', 'ms ease;\n  transform: translateX(', 'vw);\n'], ['\n  position: absolute;\n  top: 0; left: 0;\n  perspective: 1000px;\n  perspective-origin: ', ' 50%; // for some reason safari requires the x origin to be centered while other browsers require it to be offset to the left or right\n  width: 100%;\n  height: 100%;\n  z-axis: ', ';\n  transform-origin: ', ' center;\n  transform-style:preserve-3d;\n  transition: transform ', 'ms ease;\n  transform: translateX(', 'vw);\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  transform-style: preserve-3d;\n  background-color: ', ';\n  transform-origin: ', ' center;\n  transition: transform ', 'ms ease;\n  transform: rotateY(', 'deg);\n'], ['\n  display: flex;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  transform-style: preserve-3d;\n  background-color: ', ';\n  transform-origin: ', ' center;\n  transition: transform ', 'ms ease;\n  transform: rotateY(', 'deg);\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0; left: 0; bottom: 0;\n  width: 15vw;\n  min-width: 100px;\n  background-color: rgba(0,0,0,0);\n  border-style: none;\n  outline-style: none;\n  color: white;\n  cursor: pointer;\n  transform: rotateZ(180deg);\n  fill: white;\n  // background: linear-gradient(to left, rgba(0,0,0,0) , rgba(0,0,0,1));\n  z-index: 1000;\n'], ['\n  position: absolute;\n  top: 0; left: 0; bottom: 0;\n  width: 15vw;\n  min-width: 100px;\n  background-color: rgba(0,0,0,0);\n  border-style: none;\n  outline-style: none;\n  color: white;\n  cursor: pointer;\n  transform: rotateZ(180deg);\n  fill: white;\n  // background: linear-gradient(to left, rgba(0,0,0,0) , rgba(0,0,0,1));\n  z-index: 1000;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0; right: 0; bottom: 0;\n  width: 15vw;\n  min-width: 100px;\n  background-color: rgba(0,0,0,0);\n  border-style: none;\n  outline-style: none;\n  color: white;\n  cursor: pointer;\n  fill: white;\n  // background: linear-gradient(to right, rgba(0,0,0,1) , rgba(0,0,0,0));\n  z-index: 1000;\n'], ['\n  position: absolute;\n  top: 0; right: 0; bottom: 0;\n  width: 15vw;\n  min-width: 100px;\n  background-color: rgba(0,0,0,0);\n  border-style: none;\n  outline-style: none;\n  color: white;\n  cursor: pointer;\n  fill: white;\n  // background: linear-gradient(to right, rgba(0,0,0,1) , rgba(0,0,0,0));\n  z-index: 1000;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  width: 50px;\n  height: 200px;\n  float: right;\n  padding-right: 10px;\n'], ['\n  width: 50px;\n  height: 200px;\n  float: right;\n  padding-right: 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _detectBrowser = require('detect-browser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var browser = (0, _detectBrowser.detect)().name;

var ANIMATION_DURATION = 1000;

var Container = _styledComponents2.default.div(_templateObject);

var PaneWrapper = _styledComponents2.default.div(_templateObject2, function (props) {
  return browser == 'safari' || browser == 'ios' ? '50%' : props.xDirection;
}, function (props) {
  return props.paneXIndex === props.centerXIndex ? 1 : -1;
}, function (props) {
  return props.xDirection;
}, function (props) {
  return props.animationDuration;
}, function (props) {
  return getWrapperXTranslation(props);
});

var Pane = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.xDirection;
}, function (props) {
  return props.animationDuration;
}, function (props) {
  if (props.isAnimating && props.centerXIndex === props.paneXIndex) return props.xDirection === 'left' ? 90 : -90;else return 0;
});

var LeftButton = _styledComponents2.default.button(_templateObject4);
var RightButton = _styledComponents2.default.button(_templateObject5);

var Arrow = _styledComponents2.default.img(_templateObject6);

function getWrapperXTranslation(props) {

  if (props.isAnimating) {
    if (props.paneXIndex === props.centerXIndex) {
      if (props.xDirection === 'left') return 100;else return -100;
    } else {
      if (props.xDirection === 'left' && props.paneXIndex === props.leftXIndex) return 0;else if (props.xDirection === 'right' && props.paneXIndex === props.rightXIndex) return 0;else {
        if (props.paneXIndex === props.leftXIndex) return -100;else if (props.paneXIndex === props.rightXIndex) return 100;
      }
    }
  } else {
    if (props.paneXIndex !== props.centerXIndex) {
      if (props.paneXIndex === props.leftXIndex) return -100;else if (props.paneXIndex === props.rightXIndex) return 100;
    } else return 0;
  }
}

var Carousel3D = function (_Component) {
  _inherits(Carousel3D, _Component);

  function Carousel3D(props) {
    _classCallCheck(this, Carousel3D);

    var _this = _possibleConstructorReturn(this, (Carousel3D.__proto__ || Object.getPrototypeOf(Carousel3D)).call(this, props));

    _this.state = {
      isAnimating: false,
      xDirection: 'left',
      elementXIndex: 0,
      centerXIndex: 0,
      leftXIndex: 2,
      rightXIndex: 1,

      animationDuration: ANIMATION_DURATION,
      windowHeight: 0,
      windowWidth: 0
    };
    return _this;
  }

  _createClass(Carousel3D, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions.bind(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
  }, {
    key: 'updateDimensions',
    value: function updateDimensions() {
      this.setState({ windowHeight: window.innerHeight, windowWidth: window.innerWidth });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          centerXIndex = _state.centerXIndex,
          leftXIndex = _state.leftXIndex,
          rightXIndex = _state.rightXIndex,
          elementXIndex = _state.elementXIndex;

      var elements = this.props.elements || ['Pane #1', 'Pane #2', 'Pane #3'];

      var leftElementIndex = elementXIndex === 0 ? elements.length - 1 : elementXIndex - 1;
      var rightElementIndex = elementXIndex === elements.length - 1 ? 0 : elementXIndex + 1;

      var content1 = centerXIndex === 0 && elements[elementXIndex] || leftXIndex === 0 && elements[leftElementIndex] || rightXIndex === 0 && elements[rightElementIndex];
      var content2 = centerXIndex === 1 && elements[elementXIndex] || leftXIndex === 1 && elements[leftElementIndex] || rightXIndex === 1 && elements[rightElementIndex];
      var content3 = centerXIndex === 2 && elements[elementXIndex] || leftXIndex === 2 && elements[leftElementIndex] || rightXIndex === 2 && elements[rightElementIndex];

      return _react2.default.createElement(
        Container,
        null,
        _react2.default.createElement(
          PaneWrapper,
          {
            isAnimating: this.state.isAnimating,
            xDirection: this.state.xDirection,
            paneXIndex: 0,
            centerXIndex: this.state.centerXIndex,
            leftXIndex: this.state.leftXIndex,
            rightXIndex: this.state.rightXIndex,
            animationDuration: this.state.animationDuration
          },
          _react2.default.createElement(
            Pane,
            {
              isAnimating: this.state.isAnimating,
              xDirection: this.state.xDirection,
              paneXIndex: 0,
              centerXIndex: this.state.centerXIndex,
              animationDuration: this.state.animationDuration,
              backgroundColor: this.props.backgroundColor
            },
            content1
          )
        ),
        _react2.default.createElement(
          PaneWrapper,
          {
            isAnimating: this.state.isAnimating,
            xDirection: this.state.xDirection,
            paneXIndex: 1,
            centerXIndex: this.state.centerXIndex,
            leftXIndex: this.state.leftXIndex,
            rightXIndex: this.state.rightXIndex,
            animationDuration: this.state.animationDuration
          },
          _react2.default.createElement(
            Pane,
            {
              isAnimating: this.state.isAnimating,
              xDirection: this.state.xDirection,
              paneXIndex: 1,
              centerXIndex: this.state.centerXIndex,
              animationDuration: this.state.animationDuration,
              backgroundColor: this.props.backgroundColor
            },
            content2
          )
        ),
        _react2.default.createElement(
          PaneWrapper,
          {
            isAnimating: this.state.isAnimating,
            xDirection: this.state.xDirection,
            paneXIndex: 2,
            centerXIndex: this.state.centerXIndex,
            leftXIndex: this.state.leftXIndex,
            rightXIndex: this.state.rightXIndex,
            animationDuration: this.state.animationDuration
          },
          _react2.default.createElement(
            Pane,
            {
              isAnimating: this.state.isAnimating,
              xDirection: this.state.xDirection,
              paneXIndex: 2,
              centerXIndex: this.state.centerXIndex,
              animationDuration: this.state.animationDuration,
              backgroundColor: this.props.backgroundColor
            },
            content3
          )
        ),
        _react2.default.createElement(
          LeftButton,
          { onClick: this.nextXPane.bind(this, 'left') },
          _react2.default.createElement(Arrow, { src: require('./img/arrow.png') })
        ),
        _react2.default.createElement(
          RightButton,
          { onClick: this.nextXPane.bind(this, 'right') },
          _react2.default.createElement(Arrow, { src: require('./img/arrow.png') })
        )
      );
    }
  }, {
    key: 'nextXPane',
    value: function nextXPane(direction) {
      var _this2 = this;

      if (this.state.isAnimating) return;

      var elements = this.props.elements || ['Pane #1', 'Pane #2', 'Pane #3'];

      this.setState({
        xDirection: direction,
        isAnimating: true,
        animationDuration: ANIMATION_DURATION
      }, function () {

        setTimeout(function () {
          var centerXIndex = void 0,
              elementXIndex = void 0;
          if (direction === 'left') {
            centerXIndex = _this2.state.centerXIndex === 0 ? 2 : _this2.state.centerXIndex - 1;
            elementXIndex = _this2.state.elementXIndex === 0 ? elements.length - 1 : _this2.state.elementXIndex - 1;
          }
          if (direction === 'right') {
            centerXIndex = _this2.state.centerXIndex === 2 ? 0 : _this2.state.centerXIndex + 1;
            elementXIndex = _this2.state.elementXIndex === elements.length - 1 ? 0 : _this2.state.elementXIndex + 1;
          }

          var leftXIndex = centerXIndex === 0 ? 2 : centerXIndex - 1;
          var rightXIndex = centerXIndex === 2 ? 0 : centerXIndex + 1;

          _this2.setState({
            isAnimating: false,
            animationDuration: 0,
            elementXIndex: elementXIndex,
            centerXIndex: centerXIndex,
            leftXIndex: leftXIndex,
            rightXIndex: rightXIndex
          });
        }, ANIMATION_DURATION);
      });
    }
  }]);

  return Carousel3D;
}(_react.Component);

exports.default = Carousel3D;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-carousel-3d/build/Carousel3D.js
// module id = 102
// module chunks = 0